import axios from "axios";

const apiClient = axios.create({
  baseURL: GetAPIURL(),
  withCredentials: false,
  header: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
});

function GetAPIURL() {
  console.log("API URL: ", window.location.origin.toLowerCase() + "/api/v1");
  return window.location.origin.toLowerCase() + "/api/v1";
}

export default {
  setAuthHeader(authResponse) {
    if (authResponse == null) {
      apiClient.defaults.headers.common["Authorization"] = null;
      localStorage.removeItem("session");
      console.log("remove session");
    } else {
      apiClient.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${authResponse.token}`;
      localStorage.setItem("session", JSON.stringify(authResponse));
    }
  },
  setErrorHandler(errorHandler, store) {
    apiClient.interceptors.response.use(
      response => response, // return the response
      error => {
        errorHandler(error, store);
      }
    );
  },
  login(email, password) {
    return apiClient.post("/Sessions/Authenticate", {
      email: email,
      password: password
    });
  },
  logout() {
    return apiClient.delete("/Sessions/" + localStorage.getItem("session").id);
  },
  getCustomerData(startDate, endDate) {
    return apiClient.get(
      "/CustomerData?startDate=" + startDate + "&endDate=" + endDate
    );
  },
  getCustomerCurrentInfo(customerId) {
    return apiClient.get("/CustomerCurrentInfo?customerId=" + customerId);
  },
  getBillingData(customerId, startDate, endDate) {
    var path = "/BillingData";
    if (customerId != null || startDate != null || endDate != null) {
      path += "?i=0";
    }
    if (customerId != null) {
      path += "&customerId=" + customerId;
    }
    if (startDate != null) {
      path += "&startDate=" + startDate;
    }
    if (endDate != null) {
      path += "&endDate=" + endDate;
    }
    return apiClient.get(path);
  },
  getCurrentVersions() {
    return apiClient.get("/Versions/Current");
  },
  getVersions() {
    return apiClient.get("/Versions");
  },
  getVersion(versionId) {
    if (versionId != null) {
      return apiClient.get("/Versions/" + versionId);
    }
  },
  setVersionAlpha(versionId) {
    if (versionId != null) {
      return apiClient.post("/Versions/" + versionId + "/SetAlpha");
    }
  },
  setVersionBeta(versionId) {
    if (versionId != null) {
      return apiClient.post("/Versions/" + versionId + "/SetBeta");
    }
  },
  setVersionRelease(versionId) {
    if (versionId != null) {
      return apiClient.post("/Versions/" + versionId + "/SetRelease");
    }
  },
  setVersionStable(versionId) {
    if (versionId != null) {
      return apiClient.post("/Versions/" + versionId + "/SetStable");
    }
  },
  getCustomers() {
    return apiClient.get("/Customers");
  },
  getCustomer(customerId) {
    return apiClient.get("/Customers/" + customerId);
  },
  updateCustomer(customer) {
    return apiClient.put("/Customers/" + customer.customerId, customer);
  },
  duplicateCustomer(customer) {
    return apiClient.post(
      "/Customers/" + customer.customerId + "/DuplicateTest"
    );
  },
  createJobBatch(customer, batchTypeValue) {
    // var data = {jobBatchType: batchTypeValue};
    var data = batchTypeValue;
    console.log("data", data);
    return apiClient.post(
      "/Customers/" + customer.customerId + "/JobBatch",
      data,
      { headers: { "Content-Type": "text/plain" } }
    );
  },
  getCustomerJobs(customerId) {
    return apiClient.get("/Customers/" + customerId + "/Jobs");
  },
  deleteCustomerJobs(customerId) {
    return apiClient.delete("/Customers/" + customerId + "/Jobs");
  },
  getJobs() {
    return apiClient.get("/Jobs");
  },
  getLogs(customerId, startDate, endDate, page) {
    var path = "/Logs";
    if (customerId != null || startDate != null || endDate != null) {
      path += "?i=0";
    }
    if (customerId != null) {
      path += "&customerId=" + customerId;
    }
    if (startDate != null) {
      path += "&startDate=" + startDate;
    }
    if (endDate != null) {
      path += "&endDate=" + endDate;
    }
    if (page != null) {
      path += "&page=" + page;
    }

    return apiClient.get(path);
  },
  getComponents(customerId) {
    return apiClient.get("/Customers/" + customerId + "/Components");
  },
  addTheme(customerId, themeName) {
    var data = themeName;
    return apiClient.post("/Customers/" + customerId + "/Components", data, {
      headers: { "Content-Type": "text/plain" }
    });
  },
  getCurrencySymbol() {
    if (
      window.location.origin
        .toLowerCase()
        .startsWith("https://monadmanagementau")
    ) {
      return "$";
    } else {
      return "£";
    }
  }
};
